export default "__VITE_ASSET__vCsW91cC__"